//Texts within CSR flows are not currently translated
export const bannerTexts = {
  TRANSACT_AS_GUEST: 'You are transacting as a guest customer',
  LOGGED_IN_AS: 'You are logged in as',
  DISCONNECT_BTN: 'Disconnect',
  CSR_CLOSE: 'close',
  RESTRICTIONS_APPLIED: 'Restrictions are applied',
  CSR_BANNER_RESTRICTIONS_APPLY: 'Restrictions apply',
  CSR_BANNER_VERIFIED_USER: 'Verified User',
  CSR_BANNER_INSTANT_ACCESS_USER: 'Instant Access User',
  GUEST_CUSTOMER: 'Guest Customer',
  DISCONNECT_FROM_ACCOUNT_BTN: 'Disconnect From Account',
  DISCONNECT_FROM_CART_BTN: 'Disconnect From Cart'
};
